(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/core/assets/javascripts/behaviors/bind-view-radio.js') >= 0) return;  svs.modules.push('/components/numbergames/core/assets/javascripts/behaviors/bind-view-radio.js');

'use strict';

svs.numbergames.core.behaviors.BindViewRadio = Marionette.Behavior.extend({
  options: {
    channel: 'numbergames'
  },
  initialize() {
    this.context = this.options.context || this.view;
    this.context.radio = Radio.channel(this.options.channel);
  },
  onInitialize() {
    if (this.context.radio) {
      if (this.context.radioEvents) {
        this.context.bindEvents(this.context.radio, this.context.radioEvents);
      }
      if (this.context.radioRequests) {
        this.context.bindEvents(this.context.radio, this.context.radioRequests);
      }
    }
  },
  onDestroy() {
    if (this.context.radio) {
      if (this.context.radioEvents) {
        this.context.unbindEvents(this.context.radio, this.context.radioEvents);
      }
      if (this.context.radioRequests) {
        this.context.unbindEvents(this.context.radio, this.context.radioRequests);
      }
    }
  }
});

 })(window);